package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.StorefrontW500Rounded: ImageVector
    get() {
        if (_storefrontW500Rounded != null) {
            return _storefrontW500Rounded!!
        }
        _storefrontW500Rounded = Builder(name = "StorefrontW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(202.91f, 851.0f)
                quadToRelative(-37.78f, 0.0f, -64.39f, -26.61f)
                reflectiveQuadTo(111.91f, 760.0f)
                verticalLineToRelative(-315.37f)
                quadToRelative(-23.24f, -22.91f, -34.9f, -57.11f)
                quadToRelative(-11.66f, -34.19f, 0.34f, -73.67f)
                lineToRelative(42.0f, -136.0f)
                quadToRelative(8.72f, -28.39f, 31.37f, -47.19f)
                quadToRelative(22.65f, -18.79f, 52.28f, -18.79f)
                horizontalLineToRelative(556.0f)
                quadToRelative(29.63f, 0.0f, 51.9f, 18.17f)
                quadToRelative(22.27f, 18.18f, 31.75f, 47.81f)
                lineToRelative(42.0f, 136.0f)
                quadToRelative(12.0f, 39.0f, 0.22f, 72.07f)
                quadToRelative(-11.78f, 33.08f, -34.78f, 57.51f)
                lineTo(850.09f, 760.0f)
                quadToRelative(0.0f, 37.78f, -26.61f, 64.39f)
                reflectiveQuadTo(759.09f, 851.0f)
                lineTo(202.91f, 851.0f)
                close()
                moveTo(569.0f, 397.13f)
                quadToRelative(25.57f, 0.0f, 38.85f, -17.42f)
                quadToRelative(13.28f, -17.43f, 10.28f, -39.23f)
                lineToRelative(-21.76f, -137.61f)
                horizontalLineToRelative(-72.5f)
                lineTo(523.87f, 348.0f)
                quadToRelative(0.0f, 20.04f, 13.16f, 34.59f)
                quadToRelative(13.17f, 14.54f, 31.97f, 14.54f)
                close()
                moveTo(389.0f, 397.13f)
                quadToRelative(21.57f, 0.0f, 35.35f, -14.54f)
                quadToRelative(13.78f, -14.55f, 13.78f, -34.59f)
                verticalLineToRelative(-145.13f)
                horizontalLineToRelative(-72.5f)
                lineToRelative(-21.76f, 137.61f)
                quadToRelative(-3.76f, 22.32f, 9.66f, 39.49f)
                quadToRelative(13.43f, 17.16f, 35.47f, 17.16f)
                close()
                moveTo(211.0f, 397.13f)
                quadToRelative(17.04f, 0.0f, 29.71f, -12.52f)
                quadToRelative(12.66f, -12.52f, 15.42f, -31.09f)
                lineToRelative(21.52f, -150.65f)
                horizontalLineToRelative(-72.5f)
                lineToRelative(-39.28f, 131.85f)
                quadToRelative(-5.76f, 19.28f, 5.78f, 40.85f)
                quadToRelative(11.55f, 21.56f, 39.35f, 21.56f)
                close()
                moveTo(751.0f, 397.13f)
                quadToRelative(27.8f, 0.0f, 39.73f, -21.56f)
                quadToRelative(11.92f, -21.57f, 5.4f, -40.85f)
                lineToRelative(-41.28f, -131.85f)
                horizontalLineToRelative(-70.5f)
                lineToRelative(21.52f, 150.65f)
                quadToRelative(2.76f, 18.57f, 15.42f, 31.09f)
                quadToRelative(12.67f, 12.52f, 29.71f, 12.52f)
                close()
                moveTo(202.91f, 760.0f)
                horizontalLineToRelative(556.18f)
                verticalLineToRelative(-273.63f)
                quadToRelative(-4.05f, 1.52f, -5.31f, 1.64f)
                quadToRelative(-1.26f, 0.12f, -2.78f, 0.12f)
                quadToRelative(-25.33f, 0.0f, -46.3f, -8.4f)
                quadToRelative(-20.98f, -8.4f, -41.7f, -27.45f)
                quadToRelative(-18.48f, 17.05f, -41.48f, 26.45f)
                quadToRelative(-23.0f, 9.4f, -48.52f, 9.4f)
                quadToRelative(-26.52f, 0.0f, -50.02f, -9.4f)
                quadToRelative(-23.5f, -9.4f, -41.98f, -26.45f)
                quadToRelative(-17.48f, 17.05f, -39.98f, 26.45f)
                quadToRelative(-22.5f, 9.4f, -48.02f, 9.4f)
                quadToRelative(-28.28f, 0.0f, -51.9f, -9.4f)
                quadToRelative(-23.62f, -9.4f, -42.1f, -26.45f)
                quadToRelative(-21.96f, 20.05f, -43.05f, 27.95f)
                quadToRelative(-21.1f, 7.9f, -44.95f, 7.9f)
                quadToRelative(-1.52f, 0.0f, -3.54f, -0.12f)
                quadToRelative(-2.03f, -0.12f, -4.55f, -1.64f)
                lineTo(202.91f, 760.0f)
                close()
                moveTo(759.09f, 760.0f)
                lineTo(202.91f, 760.0f)
                lineTo(759.09f, 760.0f)
                close()
            }
        }
        .build()
        return _storefrontW500Rounded!!
    }

private var _storefrontW500Rounded: ImageVector? = null
